import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCashExchangeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.95 18V16.66C14.8 16.35 15.67 15.2 15.67 13.83C15.67 12.46 14.74 11.62 12.79 11.17V8.85999C13.46 9.00999 13.9 9.31999 14.24 9.68999L15.51 8.54999C14.9 7.84999 14.08 7.41999 12.96 7.29999V5.98999H11.37V7.29999C9.57003 7.50999 8.61003 8.47999 8.61003 9.93999C8.61003 11.29 9.46003 12.21 11.55 12.64V15.15C10.77 15.04 10.12 14.66 9.59003 14.11L8.34003 15.25C9.04003 16.02 9.97003 16.59 11.37 16.71V17.99H12.96L12.95 18ZM12.79 12.93C13.58 13.17 13.75 13.58 13.75 13.99C13.75 14.52 13.44 14.95 12.79 15.13V12.93ZM10.53 9.89999C10.53 9.35999 10.84 8.97999 11.55 8.83999V10.9C10.84 10.7 10.53 10.43 10.53 9.89999Z"
        fill={color}
      />
      <path
        d="M4.81001 4.81002C6.73001 2.89002 9.29001 1.83002 12 1.83002C13.75 1.83002 15.43 2.27002 16.92 3.10002L15.68 4.34002C15.34 4.66002 15.51 5.28002 15.96 5.39002L21.12 6.77002C21.56 6.91002 22.02 6.45002 21.89 6.00002L20.51 0.840017C20.4 0.390017 19.78 0.220017 19.46 0.560017L18.01 2.01002C16.21 0.920017 14.15 0.330017 12 0.330017C8.88001 0.330017 5.95001 1.54002 3.75001 3.75002C1.24001 6.25002 0.0200071 9.71002 0.390007 13.24C0.430007 13.65 0.810007 13.95 1.22001 13.91C1.63001 13.87 1.93001 13.5 1.89001 13.08C1.56001 10 2.63001 6.99002 4.81001 4.80002V4.81002Z"
        fill={color}
      />
      <path
        d="M23.61 10.76C23.57 10.35 23.19 10.05 22.78 10.09C22.37 10.13 22.07 10.5 22.11 10.92C22.44 14 21.37 17.01 19.19 19.2C17.27 21.12 14.71 22.18 12 22.18C10.25 22.18 8.57003 21.74 7.08003 20.91L8.32003 19.67C8.66003 19.35 8.49003 18.73 8.04003 18.62L2.88003 17.24C2.43003 17.1 1.98003 17.56 2.11003 18.01L3.49003 23.17C3.60003 23.62 4.21003 23.79 4.54003 23.45L5.99003 22C7.79003 23.09 9.85003 23.68 12 23.68C15.12 23.68 18.05 22.47 20.25 20.26C22.76 17.75 23.98 14.29 23.6 10.76H23.61Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCashExchangeIcon.displayName = 'PayCashExchangeIcon';
